import { ComponentType } from "react";

/**
 * OPT-IN BODY OVERRIDE for the login modal (LoginWrapper). Global routes register the
 * HomeV3 login body from LoginWrapper; whitelabel leaves this null and uses Login.tsx.
 *
 * Its own module, with no imports of its own, so a page can register without pulling
 * the login wrapper (and through it the app reducer) into its bundle — importing the
 * wrapper for this created an import cycle that broke server rendering.
 */
export type LoginBodyOverride = {
  Body: ComponentType;
  title: string;
  /** Merged into the modal's props on phones, e.g. a sheet in place of the full screen. */
  mobileModalParams?: Record<string, unknown>;
  /** Merged into the modal's props on desktop (e.g. reskin class on the card). */
  desktopModalParams?: Record<string, unknown>;
} | null;

let current: LoginBodyOverride = null;
const listeners = new Set<() => void>();

export const getLoginBodyOverride = (): LoginBodyOverride => current;

export const setLoginBodyOverride = (next: LoginBodyOverride): void => {
  current = next;
  listeners.forEach((notify) => notify());
};

export const subscribeLoginBodyOverride = (notify: () => void): (() => void) => {
  listeners.add(notify);
  return () => {
    listeners.delete(notify);
  };
};
